import React from "react"
import {
  FormControlLabel as MUIFormControlLabel,
  FormControlLabelProps as MUIFormControlLabelProps,
} from "@mui/material"

export type FormControlLabelProps =
  | ({ new?: false } & MUIFormControlLabelProps)
  | ({ new: true } & unknown)

export const FormControlLabel = React.forwardRef<
  HTMLLabelElement,
  FormControlLabelProps
>((props, ref) =>
  props.new ? null : <MUIFormControlLabel {...props} ref={ref} />,
)

FormControlLabel.displayName = "FormControlLabel"

export default FormControlLabel
